import { useEffect, useState, type ReactNode } from "react"
import { useLocation } from "react-router-dom"

// Una vez que la primera pantalla ya se montó, cada cambio de ruta entra con un
// fundido corto. La carga inicial no se anima para no retrasar el primer pintado.
let hasNavigated = false

function Entering({ children }: { children: ReactNode }) {
  const [animate] = useState(() => hasNavigated)
  useEffect(() => {
    hasNavigated = true
  }, [])
  return <div className={animate ? "motion-route" : undefined}>{children}</div>
}

export function RouteTransition({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()
  return <Entering key={pathname}>{children}</Entering>
}
